module.exports = __webpack_public_path__ + "static/img/tj_a11.2f7d2934.png";